
import { toast as sonnerToast } from "sonner"
import type { ReactNode } from "react"

export type ToastActionElement = ReactNode

export type ToastProps = {
  title?: string
  description?: ReactNode
  variant?: "default" | "destructive"
  duration?: number
  action?: ReactNode
}

export function toast(options: ToastProps) {
  const { title, description, variant, duration } = options
  
  if (variant === "destructive") {
    sonnerToast.error(title, {
      description: description as string,
      duration: duration || 5000,
    })
  } else {
    sonnerToast(title, {
      description: description as string,
      duration: duration || 5000,
    })
  }
}

export function useToast() {
  return { toast }
}

// Simple provider that does nothing (sonner handles its own state)
export function ToastProvider({ children }: { children: ReactNode }) {
  return children
}
